import toast from 'react-hot-toast';

export function elToast(msg, tipo = 'success') {

  var estilos = {
    style: {
      borderRadius: '10px',
      background: '#333',
      color: '#fff',
    }
  }

  switch (tipo) {
    case "error":
      toast.error(msg, estilos);
      break;

    case "nada":
      toast(msg, {
        duration: 5000,
        ...estilos,
      });
      break;

    case "success":
      toast.success(msg, estilos);
      break;

    case "info":
      toast(msg, {
        duration: 5000,
        icon: "❕",
        ...estilos,
      });
      break;

    case "info2":
      toast(msg, {
        icon: "❕",
        position: "top-center",
        duration: 2000,
        ...estilos,
      });
      break;

    case "info3":
      toast(msg, {
        icon: "❕",
        position: "top-center",
        duration: 3500,
        ...estilos,
      });
      break;

    case "esperar":
      toast(msg, {
        icon: "⌛",
        ...estilos,
      });
      break;

    default:
      toast.success(msg, estilos);
      break;
  }

}
